export default "__VITE_ASSET__EVnZ8$T$__"